import { createMessage } from '../actions/index';

const errorsByStatusCode = {
	400: () => createMessage('questions.error.confluence.bad.request', 'error'),
	401: () => createMessage('questions.error.user.unauthenticated', 'error'),
	403: () => createMessage('questions.error.operation.not.authorized', 'error'),
	408: () => createMessage('questions.error.request.timeout', 'error'),
	429: () => createMessage('questions.error.rate.limit.exceeded', 'error'),
	500: () => createMessage('questions.error.internal.server.failure', 'error'),
	503: () => createMessage('questions.error.service.unavailable', 'error'),
	504: () => createMessage('questions.error.request.timeout', 'error'),
	404: () => createMessage('questions.error.data.not.found', 'error'),
};

const createErrorWithMessage = (error) =>
	createMessage('questions.error.dev.failure', 'error', { message: error.message });

export const createErrorByStatusCode = (error) => {
	if (!error) {
		return errorsByStatusCode[500](error);
	}
	// 1. handles development errors from add-on REST : use message without i18n from response
	if (error.devError === true) {
		return createErrorWithMessage(error);

		// 2. handles i18n errors from add-on REST
	} else if (error.messageKey) {
		return createMessage(error.messageKey, 'error', error.params);
	}
	// 3. handles errors from Confluence REST by error code
	const errorProcessor = errorsByStatusCode[error.status];
	return (errorProcessor && errorProcessor(error)) || errorsByStatusCode[500](error);
};
